import { render, staticRenderFns } from "./revt_over.vue?vue&type=template&id=b6210578&scoped=true"
import script from "./revt_over.vue?vue&type=script&lang=js"
export * from "./revt_over.vue?vue&type=script&lang=js"
import style0 from "./revt_over.vue?vue&type=style&index=0&id=b6210578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6210578",
  null
  
)

export default component.exports